import { render, staticRenderFns } from "./reportReasonComponent.vue?vue&type=template&id=7e45367c&"
import script from "./reportReasonComponent.vue?vue&type=script&lang=js&"
export * from "./reportReasonComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports